import _get from 'lodash/get';
import { BackgroundJob } from 'graphql-common';
import downloadHandler from '@lib/utils/downloadHandler';
import { JOB_TRACKER_DOWNLOADED } from '@lib/enums/localStorageKeys';

// Cap the list so it can't grow unbounded across sessions.
const DOWNLOADED_IDS_LIMIT = 200;

const getDownloadedIds = (): string[] => {
  try {
    const raw = localStorage.getItem(JOB_TRACKER_DOWNLOADED);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

const markDownloaded = (id: string) => {
  try {
    const ids = getDownloadedIds();
    if (!ids.includes(id)) {
      localStorage.setItem(
        JOB_TRACKER_DOWNLOADED,
        JSON.stringify([...ids, id].slice(-DOWNLOADED_IDS_LIMIT)),
      );
    }
  } catch {
    // ignore storage failures — at worst the file downloads twice
  }
};

// Auto-download a completed result-bearing job (QR codes / timeline report)
// at most once. Jobs delivered by email (deliveryRecipientIds set) are never
// downloaded. Downloaded ids are kept in localStorage because after a reload
// the seed query re-reports finished jobs as fresh completions; without the
// list they would download again.
const handleJobCompletion = (job: BackgroundJob) => {
  const downloadLink = _get(job, 'result.link') as string | undefined;
  if (!downloadLink) return;
  // A job started with recipients ("Send via email") delivers its result by
  // email only — the result link is still there, but nothing is downloaded.
  if (job.deliveryRecipientIds?.length) return;
  if (getDownloadedIds().includes(job.id)) return;
  downloadHandler(downloadLink);
  markDownloaded(job.id);
};

export default handleJobCompletion;
